document.addEventListener("DOMContentLoaded", () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // main_visual 内の .date を全て取得
  const mainVisual = document.querySelector('.main_visual');
  if (!mainVisual) return;

  const dateElements = mainVisual.querySelectorAll('.date');

  dateElements.forEach(el => {
    const rawText = el.textContent.trim();
    // コンマまたは読点で分割
    const dateParts = rawText.split(/[,、]/);
    
    const futureDates = [];

    dateParts.forEach(part => {
      // 「2026年02月05日」から数値を抽出
      const match = part.match(/(\d{4})年(\d{2})月(\d{2})日/);
      if (match) {
        const year = parseInt(match[1], 10);
        const month = parseInt(match[2], 10) - 1; // 月は0始まり
        const day = parseInt(match[3], 10);

        const eventDate = new Date(year, month, day);
        
        // 開催日の「2日前」の日付を作成
        const displayLimitDate = new Date(eventDate);
        displayLimitDate.setDate(eventDate.getDate() - 2);

        // 今日が「開催日の2日前」より前であれば表示候補に残す
        // つまり、前日になった瞬間にこの条件から外れる
        if (today < displayLimitDate) {
          futureDates.push(part.trim());
        }
      }
    });

    // 曜日の保持（例：末尾の「（木）」などを抽出）
    let suffix = "";
    const lastBracket = rawText.match(/（[^）]+）$/);
    if (lastBracket) {
      suffix = lastBracket[0];
    }

    // 表示の更新
    if (futureDates.length > 0) {
      // 最も近い未来の日付を表示
      el.textContent = futureDates[0] + suffix;
    } else {
      // 全ての日程が前日を過ぎた場合
      el.textContent = "次回日程調整中";
    }
  });
});